import type { SimpleRequestConfig } from 'modules/app/types';
import type { ApiError, EmptyResponseBody, MetaAction } from 'modules/global/generic.types';
import * as actions from 'modules/hardwares/actions';
import * as types from 'modules/hardwares/actionTypes';
import type { DeleteHardwareFromDealerAction } from 'modules/hardwares/types';

const simpleRequests: Record<string, SimpleRequestConfig> = {
  [types.FETCH_HARDWARES_REQUEST]: {},
  [types.FETCH_UNASSIGNED_HARDWARES_REQUEST]: {},
  [types.LINK_HARDWARE_REQUEST]: {
    notifications: {
      success: { id: 'hardware.link.success', defaultMessage: 'The hardware has been successfully added' },
      failure: { id: 'hardware.link.failure', defaultMessage: 'The hardware failed to be added' },
    },
  },
  [types.PATCH_STATUS_HARDWARE_REQUEST]: {
    notifications: {
      success: { id: 'hardware.update.success', defaultMessage: 'The hardware has been successfully updated' },
      failure: { id: 'hardware.update.failure', defaultMessage: 'The hardware failed to be updated' },
    },
  },
  [types.DELETE_HARDWARE_REQUEST]: {
    callbacks: {
      success: (_: EmptyResponseBody, meta: MetaAction, { payload }: DeleteHardwareFromDealerAction) =>
        actions.deleteHardwareFromDealerSuccess(payload.hardwareId, meta),
      failure: (error: ApiError, meta: MetaAction, { payload }: DeleteHardwareFromDealerAction) =>
        actions.deleteHardwareFromDealerFailure(error, { ...meta, entityId: payload.hardwareId }),
    },
    notifications: {
      success: { id: 'hardware.delete.success', defaultMessage: 'The hardware has been successfully deleted from dealership' },
      failure: { id: 'hardware.delete.failure', defaultMessage: 'The hardware could not be deleted from dealership' },
    },
  },
};

export default simpleRequests;
